import { render, staticRenderFns } from "./Forward.vue?vue&type=template&id=6029b0c6&scoped=true&"
import script from "./Forward.vue?vue&type=script&lang=js&"
export * from "./Forward.vue?vue&type=script&lang=js&"
import style0 from "./Forward.vue?vue&type=style&index=0&id=6029b0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6029b0c6",
  null
  
)

export default component.exports